var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8GithubSideBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.061,
    height: 10.062,
    viewBox: "0 0 10.061 10.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #586f93;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_github_1",
    className: "cls-1",
    d: "M9.031,4a5.031,5.031,0,1,0,5.031,5.031A5.036,5.036,0,0,0,9.031,4Zm0,.755a4.277,4.277,0,0,1,1.258,8.364V11.832a1.233,1.233,0,0,0-.677-1.1,2.432,2.432,0,0,0,1.745-1.2,1.669,1.669,0,0,0-.2-1.833,1.741,1.741,0,0,0-.06-1.42,1.4,1.4,0,0,0-1.115.635,3.067,3.067,0,0,0-1.9,0,1.4,1.4,0,0,0-1.114-.633,1.439,1.439,0,0,0-.017,1.368,1.677,1.677,0,0,0-.262,1.856,2.419,2.419,0,0,0,1.759,1.229,1.235,1.235,0,0,0-.65.849H7.467a.7.7,0,0,1-.629-.356,1.141,1.141,0,0,0-.586-.436c-.121-.013-.2.079-.1.161.357.243.382.641.525.9a.844.844,0,0,0,.7.446h.395v.818A4.277,4.277,0,0,1,9.031,4.755Z",
    transform: "translate(-4 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GithubSideBar);
export default __webpack_public_path__ + "static/media/icons8_github_Side-bar.6559a61b6740d324d488e54ea4e1e8a4.svg";
export { ForwardRef as ReactComponent };